import { render, staticRenderFns } from "./classSignin.vue?vue&type=template&id=a2d0c638&scoped=true&"
import script from "./classSignin.vue?vue&type=script&lang=ts&"
export * from "./classSignin.vue?vue&type=script&lang=ts&"
import style0 from "./classSignin.vue?vue&type=style&index=0&id=a2d0c638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d0c638",
  null
  
)

export default component.exports